import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { useRedux } from 'util/hook/redux';

import { wrapAuthFetch } from 'util/api';
import { isEmpty } from 'util/helper';

import { openNormalAlert, openWarningAlert } from './alert';

const addContact = createAction(
	'ADD_CONTACT',
	(type, name, phone, zipCode, address) => async dispatch => {
		if (isEmpty(name) || isEmpty(phone)) {
			throw openWarningAlert('必填欄位未填寫');
		}

		if (type !== 'SHOP' && (isEmpty(zipCode) || isEmpty(address))) {
			throw openWarningAlert('必填欄位未填寫');
		}

		const contactData = {
			type,
			name,
			phone,
			zip_code: '',
			address: '',
		};

		if (type !== 'SHOP') {
			contactData.zip_code = zipCode;
			contactData.address = address;
		}

		const { status, data } = await wrapAuthFetch('cart/address/create', {
			method: 'POST',
			body: JSON.stringify(contactData),
		});

		if (status !== 200) {
			throw openWarningAlert('新增失敗');
		}

		dispatch(openNormalAlert(`已將「${name}」儲存為常用收件人`));

		return data;
	},
);

const updateContact = createAction(
	'UPDATE_CONTACT',
	async (id, type, name, phone, zipCode, address) => {
		const contactData = {
			type,
			name,
			phone,
			zip_code: '',
			address: '',
		};

		if (type !== 'SHOP') {
			contactData.zip_code = zipCode;
			contactData.address = address;
		}

		const { status } = await wrapAuthFetch(`cart/address/${id}`, {
			method: 'PUT',
			body: JSON.stringify(contactData),
		});

		if (status !== 200) {
			return { data: {}, list: [] };
		}

		return { id, name, phone, zip_code: zipCode, address };
	},
);

const deleteContact = createAction('DELETE_CONTACT', async id => {
	const { status } = await wrapAuthFetch(`cart/address/${id}`, {
		method: 'DELETE',
	});

	if (status !== 200) {
		return { id: -1 };
	}

	return { id };
});

export const getContact = createAction('GET_CONTACT', async type => {
	const { status, data } = await wrapAuthFetch('cart/address', { method: 'GET' }, { type });

	if (status !== 200) {
		return { data: {}, list: [] };
	}

	const contactData = {};
	const list = data.map(item => {
		contactData[item.id] = item;

		return item.id;
	});

	return { data: contactData, list };
});

const reducer = {
	contact: handleActions(
		{
			GET_CONTACT_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_CONTACT_FULFILLED: (state, action) => ({
				...state,
				data: action.payload.data,
				list: action.payload.list,
				loading: false,
			}),

			ADD_CONTACT_FULFILLED: (state, action) => ({
				...state,
				data: {
					...state.data,
					[action.payload.id]: action.payload,
				},
				list: [...state.list, action.payload.id],
				loading: false,
			}),

			UPDATE_CONTACT_FULFILLED: (state, action) => ({
				...state,

				data: {
					...state.data,
					[action.payload.id]: action.payload,
				},
				loading: false,
			}),

			DELETE_CONTACT_FULFILLED: (state, action) => ({
				...state,

				list: state.list.filter(id => action.payload.id !== id),
			}),
		},
		{
			data: {},
			list: [],
			loading: false,
		},
	),
};

const mapHooksToState = createSelector(
	state => state.contact.data,
	state => state.contact.list,
	(data, list) => ({
		contact: list.map(id => data[id]),
	}),
);

export const useContact = () =>
	useRedux(mapHooksToState, { getContact, addContact, updateContact, deleteContact });

export default { reducer };
